// Import Dependencies
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// Import components
import Checkbox from '../Checkbox';

// Import Utilities
import { getClassNames, isMediaMatched } from '../../../utils';

const Expandable = ({
  id, label, advanced, cyop, cyopAdvanced, ...props
}) => {
  const [active, setActive] = useState(false);
  const contentRef = useRef(null);
  const contentWrapper = useRef(null);
  const mediaQuery = isMediaMatched(1200);

  useEffect(() => {
    if (!mediaQuery) {
      contentRef.current.style.maxHeight = active ? `${contentRef.current.scrollHeight}px` : '0px';
      contentWrapper.current.classList.add('has-expandable-open');
    } else {
      const maxHeightLimit = advanced
        ? window.innerHeight - 232
        : window.innerHeight - 176;

      const maxHeight = contentRef.current.scrollHeight < maxHeightLimit
        ? contentRef.current.scrollHeight
        : maxHeightLimit;

      contentRef.current.style.maxHeight = `${maxHeight}px`;
      contentWrapper.current.classList.remove('has-expandable-open');
    }
  }, [contentRef, active, contentWrapper, mediaQuery, advanced]);

  const handleToggleTouch = () => {
    if (!mediaQuery) setActive(!active);
  };

  const handleToggleDesktop = () => {
    if (mediaQuery) setActive(!active);
  };

  return (
    <div // eslint-disable-line
      className={getClassNames(props, 'c-expandable', {
        'c-expandable--cyop': cyop,
        'c-expandable--cyop-advanced': cyopAdvanced,
        'is-open': active,
      })}
      ref={contentWrapper}
      onMouseEnter={handleToggleDesktop}
      onMouseLeave={handleToggleDesktop}
    >
      <button
        type="button"
        className={advanced ? 'c-expandable__header c-expandable__header--advanced' : 'c-expandable__header'}
        id={id}
        onClick={handleToggleTouch}
      >
        <p className={advanced ? 'c-filterbar__advanced-text c-expandable__title' : 'c-expandable__title'}>{label}</p>
        <span className={active ? 'c-expandable__arrow  is-rotate' : 'c-expandable__arrow'}>
          <svg className={advanced ? 'c-expandable__grey-arrow' : ''}>
            <use xlinkHref="#chevron-down" />
          </svg>
        </span>
      </button>

      <div className="c-expandable__content" ref={contentRef}>
        <Checkbox isDark={!cyop} {...props} />
      </div>
    </div>
  );
};

Expandable.propTypes = {
  advanced: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  cyop: PropTypes.bool,
  cyopAdvanced: PropTypes.bool,
};

Expandable.defaultProps = {
  advanced: false,
  cyop: false,
  cyopAdvanced: false,
};

export default Expandable;
